import { STATE_COLORS } from './statusColors';

// Mirrors src/Domain/Enums/RiskStatus.cs — serialized as integers (enum index).
export const RISK_STATUS = Object.freeze({
  OPEN: 0,
  MITIGATING: 1,
  PENDING_ACCEPTANCE: 2,
  ACCEPTED: 3,
});

export const RISK_STATUS_LABELS = Object.freeze({
  [RISK_STATUS.OPEN]: 'Open',
  [RISK_STATUS.MITIGATING]: 'Mitigating',
  [RISK_STATUS.PENDING_ACCEPTANCE]: 'Pending Acceptance',
  [RISK_STATUS.ACCEPTED]: 'Accepted',
});

export const RISK_STATUS_COLORS = Object.freeze({
  [RISK_STATUS.OPEN]: STATE_COLORS.OPEN,
  [RISK_STATUS.MITIGATING]: STATE_COLORS.INPROGRESS,
  [RISK_STATUS.PENDING_ACCEPTANCE]: STATE_COLORS.INPROGRESS,
  [RISK_STATUS.ACCEPTED]: STATE_COLORS.COMPLETE,
});

// Mirrors src/Domain/Enums/RiskSourceType.cs — serialized as integers (enum index).
// Traces where a register entry came from so the list can label and filter by origin.
export const RISK_SOURCE_TYPE = Object.freeze({
  FMECA: 0,
  PROTOCOL_DEVIATION: 1,
});

export const RISK_SOURCE_TYPE_LABELS = Object.freeze({
  [RISK_SOURCE_TYPE.FMECA]: 'FMECA',
  [RISK_SOURCE_TYPE.PROTOCOL_DEVIATION]: 'Protocol Deviation',
});

export const RISK_SOURCE_TYPE_COLORS = Object.freeze({
  [RISK_SOURCE_TYPE.FMECA]: 'default',
  [RISK_SOURCE_TYPE.PROTOCOL_DEVIATION]: 'warning',
});

// Mirrors src/Domain/Enums/MitigationActionStatus.cs — serialized as integers.
export const MITIGATION_ACTION_STATUS = Object.freeze({
  OPEN: 0,
  IN_PROGRESS: 1,
  DONE: 2,
  VERIFIED: 3,
});

export const MITIGATION_ACTION_STATUS_LABELS = Object.freeze({
  [MITIGATION_ACTION_STATUS.OPEN]: 'Open',
  [MITIGATION_ACTION_STATUS.IN_PROGRESS]: 'In Progress',
  [MITIGATION_ACTION_STATUS.DONE]: 'Done',
  [MITIGATION_ACTION_STATUS.VERIFIED]: 'Verified',
});

export const MITIGATION_ACTION_STATUS_COLORS = Object.freeze({
  [MITIGATION_ACTION_STATUS.OPEN]: STATE_COLORS.OPEN,
  [MITIGATION_ACTION_STATUS.IN_PROGRESS]: STATE_COLORS.INPROGRESS,
  // Done = work finished, awaiting verification — still in progress.
  [MITIGATION_ACTION_STATUS.DONE]: STATE_COLORS.INPROGRESS,
  [MITIGATION_ACTION_STATUS.VERIFIED]: STATE_COLORS.COMPLETE,
});
